import styled from "@emotion/styled";

export const ReplacementsFlyoutWrapper = styled.div({
	width: "375px"
});

export const ReplacementsFlyoutScrollableWrapper = styled.div({
	overflowY: "scroll",
	height: "calc(100vh - 200px)"
});

export const ReplacementsFlyoutHeader = styled.div({
	display: "flex",
	justifyContent: "space-between",
	alignItems: "center",
	padding: "0px 16px",
	h5: {
		margin: "16px 0"
	}
});
